import Vue from 'vue';
import App from './App.vue';
import router from './system/engine/router';
import fontawesome from './library/fontawesome';
import sweetalert2 from './library/sweetalert2';
import bootstrapVue from 'bootstrap-vue';
import i18n from './system/language';
import ElementUI from 'element-ui';
import VueTreeNavigation from 'vue-tree-navigation';
import VueQuillEditor from 'vue-quill-editor';
import General from './system/model/general.js'

import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './library/dripicons/index.css';
import './assets/css/main.css';
import './system/engine/permission';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(bootstrapVue);
Vue.use(ElementUI);
Vue.use(VueTreeNavigation);
Vue.use(VueQuillEditor);
Vue.use(General);

Vue.config.productionTip = false;

new Vue({
	i18n,
	router,
	render: h => h(App),
}).$mount('#app');